<template>
	<div class="captail_wrap registrationSteps position-relative fullLoader p-0 w-100">
		<loader v-if="pageLoader"></loader>
		<div class="middle_section m-0">
			<div class="top_searchbars">
				<div class="row">
					<div class="col-12">
					<div class="cap_logo_steps p-3 d-flex justify-content-between align-items-center">
                            <router-link to="/home"><img src="../../../../../static/website/images/logo.png" alt="Captail wallet"></router-link>
                            <div class="rightBack d-flex align-items-center">
                            <router-link  class="backToDash mr-2" :to="'/corporate-step3'"><feather type="chevron-left"></feather></router-link>
							<router-link class="backToDash" :to="'/home'"><feather type="home"></feather></router-link>
                            </div>
                        </div>
						
					</div>
				</div>
			</div>
			
			<div class="mid_scroll_content d-flex  justify-content-center">
				<section class="stepsForm-include valigncenter border-0 w-100">
					<div class="row justify-content-center w-100">
					<alert-notification v-if="notification_msg != ''"/>
						<form class="col-12" data-toggle="validator" method="post" enctype="multipart/form-data" id="individualForm" v-on:submit.prevent="submitIndividual()">
							<div class="row justify-content-center">
								
								<div class="col-12 col-lg-6 stepBorder box-shadow text-center corporate-step4-inc" >
									<div  v-if="showTab == index" v-for="(value,key,index) in documentsDescription">
										<h3 class="text-center mb-3">{{value.title}}</h3>
										<p class="smTrue mb-0">{{value.description}} </p>
									</div>
									<div v-if="showTab == index" v-for="(value, key, index) in documentsByName">
										<!-- image preview section -->
										<div class="d-flex loopUpload   mt-3 mt-md-4">
											<div class="attachmenttSatus" v-if="value.data.length >0" v-for="(val,ind) in value.data">
												<div v-if="val.name != ''">
													<vue-pdf v-if="val.name != '' && val.file.type == 'application/pdf'" :src="addfileImage(val.file)" />
													<img v-else-if="val.name != ''" :src="addfileImage(val.file)" style="height: 50px;"/>
													<!-- <p>{{val.name}} size = {{parseInt(val.file.size / 1024)}} kB</p> -->
													<span class="deletedoc">
														<feather type="x" @click="clearFileAddMore(key,ind)"></feather>
													</span> 
												</div>
											</div>
											<!-- show uploaded image --> 
											<div class="attachmenttSatus"  v-if="documentJsonData[key] != undefined" v-for="val in documentJsonData[key]">
												<a class="" :href="$env_var.docsLink+'user&id='+get_user.profile.user_id+'&doc='+ val.name" target="_blank()" >
													<vue-pdf height= "50px" v-if="val.name.split('.')[val.name.split('.').length -1].toLowerCase() == 'pdf'" :src="$env_var.docsLink+'user&id='+get_user.profile.user_id+'&doc='+ val.name" />
													<img height= "50px" v-else :src="$env_var.docsLink+'user&id='+get_user.profile.user_id+'&doc='+ val.name" />
												</a> 
												<span class="deletedoc" :class="(pageLoader)?'disabled':''">
													<feather type="trash-2"  v-on:click.stop.prevent="deleteFunc(key,val.id)"></feather>
												</span>
											</div>
										</div>
										<div class="alert alert-danger d-flex align-items-center justify-content-between" role="alert" v-if="docValidation">please upload file <feather type="x" @click="docValidation = false"></feather></div>
										<!-- {{documentJsonData}} -->
										<div class="oneFive d-flex justify-content-end">
											<p class="mb-2">{{index + 1}} out of 8 Documents</p>
										</div>
										<div>
											<div class="loopUpload">
												<div class="uploadProof-row p-3 d-flex justify-content-between align-items-center">
													<div class="uploadText text-left">
														<h5>{{value.description}}</h5>
													</div>
													<!-- add image input -->
													<div class="upload-btn-wrapper">
														<p class="btn d-flex align-items-center"><feather type="upload" class="mr-2"></feather> Add file</p>
														<input type="file" name="document[]" :id="key" :ref="key" @change="addMoreFileChange( $event.target.files[0], key)"/>
													</div>
												</div>
												<p>Maximum files size of can be uploaded up to {{$env_var.fileSize.totalSize}} {{$env_var.fileSize.type}}</p>
												<div class="alert alert-info d-flex align-items-center justify-content-between" role="alert" v-if="lengthErrMsg">Maximum 5 files can upload <feather type="x" @click="lengthErrMsg = false"></feather></div>
												<!-- All files size error msz -->
												<div class="alert alert-danger d-flex align-items-center justify-content-between" role="alert" v-if="totalSizeErrMsg">files size can be maximum {{$env_var.fileSize.totalSize}} {{$env_var.fileSize.type}} <feather type="x" @click="totalSizeErrMsg = false"></feather></div>
												<!-- single files size error msz -->
												<div class="alert alert-danger d-flex align-items-center justify-content-between" role="alert" v-if="individualSizeErrMsg">files size can be maximum {{$env_var.fileSize.individualSize}} {{$env_var.fileSize.type}} <feather type="x" @click="individualSizeErrMsg = false"></feather></div>
											</div>
										</div> 
										
										<div class="submitButton text-center my-4 mobRotate">
											<input type="button" class="backButton mr-2" value="Back" v-show="showTab > 0"  @click.prevent.stop="showTab -= 1">
											<input type="submit" class="cap_btn blue px-4 large_btn"  :class="(pageLoader)?'disabled':''" :value="(showTab == 7)?'Submit':'Next'" name="" required="" >
										</div>
									</div>

								</div>
							</div>
						</form>
					</div>
				</section>
			</div>
		</div>
	</div>
</template>

<script>
import { registerStepsMixins } from '@/plugins/registerSteps'
export default {
    name: 'step-six',
	mixins: [registerStepsMixins],
    data() {
        return {
			pageLoader : false,
			notification_msg:'',
            notification_type:'',
			submitted : false,
			doc_array : [],
			identity_document : '',
			govt_document2 : '',
			govt_document3 : '',
			brand_file_request : '',
			showTab : 0,

			lengthErrMsg : false,
			totalSizeErrMsg : false,
			individualSizeErrMsg : false,
			
			documentJsonData : {},
			documentsByName : {
				'Letter_Of_Authorization' : { description : 'Letter Of Authorization', data:[]},
				// 'Address_Proof' : { description : 'Identity & address proof beneficial owner with ownership or owning more than 25% shareholding or voting rights', data:[]},
				'Address_Proof' : { description : 'Upload Proof of Residence', data:[]},
				'Certification_of_Incorporation' : { description : 'Attach Certification of Incorporation', data:[]},
				'Memorandum_Articles' : { description : 'Memorandum & Articles of Association Or Other Relevant Founding Document', data:[]},
				'Business_Address' : { description : 'Document Showing Registered Business Address', data:[]},
				'Proof_of_the_Current_Directors' : { description : 'Identity and Address Proof of the Current Director(s)', data:[]},
				// 'Passport' : { description : 'Upload Copy Of Passport', data:[]},
				'Passport' : { description : 'Identity & address proof of beneficial owner(s', data:[]},
				'Additional_Document' : { description : 'Additional Documents', data:[]},
			},
			documentsDescription : {
				'Letter_Of_Authorization' : { title : 'Letter Of Authorization', description : 'Please upload Letter Of Authorization stating you have the authority to open an account on the organization’s behalf.'},
				'Address_Proof' : {title : ' Proof of Residence', description : 'Authorized representatives must upload a proof of their residence. Proof of address from the country of residence is where you primarily live, do banking and receive important emails'},
				'Certification_of_Incorporation' : { title : 'Certification of Incorporation',description : 'To verify your corporate account, you will be required to submit general business information & relevant documents. Please ensure all attachments must be originals and include English translations.'},
				'Memorandum_Articles' : { title : ' Relevant Founding Document',description : 'Please upload relevant founding documents that shows the list of current director, shareholders and ultimate beneficiary owners. '},
				'Business_Address' : { title : ' Registered Business Address Proof',description : 'Please upload a document that shows your business address. Document can be a utility bill, bank statement, rent lease agreement or others but not less than 6 months old. '},
				'Proof_of_the_Current_Directors' : {title : 'Identity and Address Proof of the Current Director(s)', description : 'Please upload the identity and proof of address of the current directors. If the organization has more than one director, please upload additional documents at the end of the form'},
				'Passport' : { title : 'Identity & address proof of beneficial owner(s)',description : 'Beneficial owner is a person with significant control. They directly or indirectly holds more than 25% of the company’s issued share capital or voting rights, or holds the right to appoint or remove a majority of board of directors, OR has significant influence or control of the organization.'},
				'Additional_Document' : { title : 'Additional Documents',description : 'Please upload any pending documents here. Kindly note that the number of individual attachments you can upload is limited so, please combine attachments into fewer images or PDF, Word, or other text documents and upload. Adding multiple documents allowed'},
			},

			docValidation: false
		}
	},
	methods: {
		deleteFunc(getData1, docId){
			// console.log('del',getData1,docId);
			if(this.pageLoader){return;}
			let input_json={
				'globalParams' :{
					'id' : docId
				},
				'localParams' :{ "parameter" : this , 'getData' : getData1}
			}
			this._runDelDoc(input_json)
        },
        addfileImage(file){
            return URL.createObjectURL(file);
        },
        addMoreFileChange(file,docType){
			this.docValidation = false
			let length = this.documentsByName[docType].data.length
			length += (this.documentJsonData[docType] != undefined) ? this.documentJsonData[docType].length : 0
			if(length == 5){
				this.lengthErrMsg = true
			}else if( file.size / this.$env_var.fileSize.conversion > this.$env_var.fileSize.individualSize ){
				this.individualSizeErrMsg = true
			}else{
				this.individualSizeErrMsg = false
				this.lengthErrMsg = false
				this.documentsByName[docType].data.push({
					'file':file,
					'name':file.name
				})
			}
			document.getElementById(docType).value = ''
        },
        clearFileAddMore(docType,index){
			this.documentsByName[docType].data.splice(index, 1);
			this.lengthErrMsg = false
			this.totalSizeErrMsg = false
			this.individualSizeErrMsg = false
        },
		clearOld(){
			let docType = Object.keys(this.documentsByName)[this.showTab]
			this.documentsByName[docType].data = []
			// this.documentsByName[docType].data = [{ 'name': '', 'file': '' }]
		},
		submitIndividual(){
			if(this.pageLoader){return;}
			this.lengthErrMsg = false
			const _that = this
			_that.submitted = true;
			let formRequest = document.getElementById('individualForm');
			let form_name = new FormData();
			let fileSize = 0
			let docType = Object.keys(this.documentsByName)[this.showTab]
			let haveFiles = 0
			let filelength = this.documentsByName[docType].data.length
			filelength += (this.documentJsonData[docType] != undefined) ? this.documentJsonData[docType].length : 0
			this.documentsByName[docType].data.forEach( item => {
				if(item.name != ''){
					form_name.append('document[]', item.file, docType + '.'+ item.name.split('.')[item.name.split('.').length -1] );
					form_name.append('documenttype', docType);
					haveFiles += 1;
					fileSize += item.file.size
				}
			});
			if(haveFiles > 0){
				this.docValidation = false	
				if( fileSize / this.$env_var.fileSize.conversion > this.$env_var.fileSize.totalSize ){
					this.totalSizeErrMsg = true
					_that.$notify({
						group: 'foo',
						type: 'error',
						text: 'files size should be lesser then 60 MB',
						duration: 10000,
						closeOnClick: true
					});
				}else{
					this.totalSizeErrMsg = false
					this.individualSizeErrMsg = false
					let input_json={
						'globalParams' :{
							'form' : form_name
						},
						'localParams' :{ "parameter" : _that , type : 'form'}
					}
					if(_that.showTab == 7){
						input_json.localParams.step = '4'
						form_name.append('step', '4');
					}
					_that._runCorStep7(input_json)
				}
			}else if(this.showTab == 7){
				let input_json={
					'globalParams' :{
						'step' : '4'
					},
					'localParams' :{ "parameter" : _that, step : '4'}
				}
				_that._runCorStep7(input_json)
			}
			else if(filelength == 0){
				this.docValidation = true
			}else{
				if(_that.showTab == 7){
					_that.$router.replace('/home')
				}else{this.showTab += 1}
			}
		},
		stepInfo(){
			this._runGetStepInfo({'globalParams' :{"step" : '4'},'localParams' :{ "parameter" : this}})
		}
	},
	created(){
		this.stepInfo()
		// let docArr = Object.keys(this.documentsByName)
		// let _that = this
		// docArr.forEach(item => {
		// 	_that.documentsByName[item].data.push({ 'name': '', 'file': '' })
		// })
	}
}
</script>



// WEBPACK FOOTER //
// src/components/website/registerSteps/corporate/corporate_step4.vue